import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from '@azure/msal-react';
import SideNav from './sidenav';
import Navbar from './navbar';
import { Outlet } from 'react-router-dom';
import AutoRedirectToAzureB2C from '../Login/AutoLoginAzureAd';
import { isSidebarCollapsedAtom } from '../../atoms/sidebar';
import { useAtom } from 'jotai';

export const PageLayout = () => {
  const [isCollapsed, setIsCollapsed] = useAtom(isSidebarCollapsedAtom);

  const handleCollapsed = () => setIsCollapsed(!isCollapsed);

  const sidebarW = isCollapsed ? '100px' : '16.666667%';

  return (
    <>
      <AuthenticatedTemplate>
        <div
          className="flex flex-row min-h-screen bg-[#F4F4F4]"
          style={{ overflowX: 'hidden' }}
        >
          {/* fixed sidebar */}
          <div
            className={`fixed h-full z-10 ${isCollapsed ? 'w-[100px]' : 'w-1/6'} rounded-md bg-[#FCFCFC]`}
          >
            <SideNav handleCollapseOfParent={handleCollapsed} />
          </div>

          {/* main content — offset by exactly the sidebar width */}
          <div
            className="flex flex-col min-h-screen bg-[#F4F4F4]"
            style={{
              marginLeft: sidebarW,
              width: `calc(100% - ${sidebarW})`,
              maxWidth: `calc(100% - ${sidebarW})`,
              overflowX: 'hidden',
              overflowY: 'visible',
              boxSizing: 'border-box',
            }}
          >
            {/* fixed navbar — same width as content area */}
            <div
              className="fixed top-0 z-20 bg-white shadow-sm"
              style={{
                left: sidebarW,
                width: `calc(100% - ${sidebarW})`,
              }}
            >
              <Navbar isCollapsed={isCollapsed} />
            </div>

            {/* page content */}
            <div
              className="pt-16 min-h-screen"
              style={{
                overflowX: 'hidden',
                overflowY: 'visible',
                boxSizing: 'border-box',
              }}
            >
              <div
                className="mt-4 mx-4 rounded-2xl bg-[#F4F4F4]"
                style={{
                  overflowX: 'hidden',
                  overflowY: 'visible',
                  boxSizing: 'border-box',
                }}
              >
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <AutoRedirectToAzureB2C />
      </UnauthenticatedTemplate>
    </>
  );
};